import { createSlice } from "@reduxjs/toolkit";

// Define initial state for the slice.
const initialState = {
  data: [],
  loading: false,
  error: null,
  currency: null,
  exportStatus: { loading: false, error: null },
};

//  Define slice and it's reducer functions.

const currencySlice = createSlice({
  name: "currency",
  initialState,
  reducers: {
    setData(state, action) {
      state.data = action.payload;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
    },
    setCurrency(state, action) {
      state.currency = action.payload;
    },
    setExportStatus(state, action) {
      state.exportStatus = {
        loading: action.payload.loading,
        error: action.payload.error,
      };
    },
    resetState(state) {
      state.data = [];
      state.loading = false;
      state.error = null;
      state.currency = null;
      state.exportStatus = { loading: false, error: null };
    },
  },
});

export const currencyAction = currencySlice.actions;

export default currencySlice;
